export const dsQuery = `SELECT 
    -- Observation Sheet
    observationSheet.id AS id,
    observationSheet.inwardTestId AS observationSheet_inwardTestId,
    observationSheet.testId AS observationSheet_testId,
    observationSheet.testNumber AS observationSheet_testNumber,
    observationSheet.boreHoleNo AS observationSheet_boreHoleNo,
    observationSheet.startTestingDate AS observationSheet_startTestingDate,
    observationSheet.endTestingDate AS observationSheet_endTestingDate,
    observationSheet.ulrNumber AS observationSheet_ulrNumber,
    observationSheet.configuration AS observationSheet_configuration,
    observationSheet.jobAssignedUser AS observationSheet_jobAssignedUser,
    observationSheet.jobAssignedDate AS observationSheet_jobAssignedDate,
    observationSheet.totalReadings AS observationSheet_totalReadings,
    observationSheet.testedBy AS observationSheet_testedBy,
    observationSheet.approvedBy AS observationSheet_approvedBy,
    observationSheet.testedByDate AS observationSheet_testedByDate,
    observationSheet.approvedByDate AS observationSheet_approvedByDate,
    observationSheet.masterUsedId AS observationSheet_masterUsedId,
    observationSheet.fileAttachment AS observationSheet_fileAttachment,
    observationSheet.additionalTestDetails AS observationSheet_additionalTestDetails,
    observationSheet.requestApproval AS observationSheet_requestApproval,
    observationSheet.certificateId AS observationSheet_certificateId,
    observationSheet.deletedTableIds AS deletedTableIds,
    observationSheet.status AS observationSheet_status,
    
     -- Tested By User Info
    testedByUser.userName AS testedBy_userName,
    testedByUser.usersign AS testedBy_userSign,
    testedByEmpData.hrDesignation AS testedBy_hrDesignation,

    -- Approved By User Info
    approvedByUser.userName AS approvedBy_userName,
    approvedByUser.usersign AS approvedBy_userSign,
    approvedByEmpData.hrDesignation AS approvedBy_hrDesignation,

    -- Certificate
    certificate.id AS certificate_id,
    certificate.reportNumber AS certificate_reportNumber,
    certificate.ulrNumber AS certificate_ulrNumber,
    certificate.rejectedBy AS certificate_rejectedBy,
    certificate.preparedBy AS certificate_preparedBy,
    certificate.preparedDate AS certificate_preparedDate,
    certificate.reviewedBy AS certificate_reviewedBy,
    certificate.reviewedDate AS certificate_reviewedDate,
    certificate.authorizedBy AS certificate_authorizedBy,
    certificate.authorizedDate AS certificate_authorizedDate,
    certificate.status AS certificate_status, 

    -- Inward
    inward.id AS inward_id,
    inward.jobId AS inward_jobId,
    inward.customerName AS inward_customerName,
    inward.address AS inward_address,
    inward.inwardDate AS inward_inwardDate,
    inward.testingType AS inward_testingType,
    inward.disciplineId AS inward_disciplineId,
    inward.contactPerson AS inward_contactPerson,
    inward.labReferenceNo AS inward_labReferenceNo,
    inward.sampleDetails AS inward_sampleDetails,
    inward.location AS inward_location,
    inward.principleClient AS inward_principleClient,
    inward.dispatchMode AS inward_dispatchMode,
    inward.testingStartDate AS inward_testingStartDate,
    inward.reportDeliveryDate AS inward_reportDeliveryDate,
    inward.createdBy AS inward_createdBy,
    inward.approvedBy AS inward_approvedBy,
    inward.status AS inward_status,

    -- Job Register
    jobRegister.id AS jobRegister_id,
    jobRegister.jobNumber AS jobRegister_jobNumber,
    jobRegister.jobDate AS jobRegister_jobDate,
    jobRegister.clientInitials AS jobRegister_clientInitials,
    jobRegister.workOrderNo AS jobRegister_workOrderNo,
    jobRegister.workOrderPdf AS jobRegister_workOrderPdf,
    jobRegister.reference AS jobRegister_reference,
    jobRegister.department AS jobRegister_department,
    jobRegister.clientName AS jobRegister_clientName,
    jobRegister.address AS jobRegister_address,
    jobRegister.contactPerson AS jobRegister_contactPerson,
    jobRegister.ContactNo AS jobRegister_ContactNo,
    jobRegister.panNo AS jobRegister_panNo,
    jobRegister.gstNumber AS jobRegister_gstNumber,
    jobRegister.principleClient AS jobRegister_principleClient,
    jobRegister.projectHodId AS jobRegister_projectHodId,
    jobRegister.projectInchargeId AS jobRegister_projectInchargeId,
    jobRegister.workOrderAmount AS jobRegister_workOrderAmount,
    jobRegister.workOrderValidity AS jobRegister_workOrderValidity,
    jobRegister.inclusionsHRComplaince AS jobRegister_inclusionsHRComplaince,
    jobRegister.inclusionsWorkmenCompensationPolicy AS jobRegister_inclusionsWorkmenCompensationPolicy,
    jobRegister.inclusionsTPI AS jobRegister_inclusionsTPI,
    jobRegister.siteState AS jobRegister_siteState,
    jobRegister.siteCity AS jobRegister_siteCity,
    jobRegister.projectOwnerId AS jobRegister_projectOwnerId,
    jobRegister.serviceId AS jobRegister_serviceId,
    jobRegister.projectName AS jobRegister_projectName,

    -- Material Scope
    materialScope.id AS materialScope_id,
    materialScope.MaterialName AS materialScope_MaterialName,
    materialScope.discplineId AS materialScope_discplineId,

    -- Discipline
    discipline.id AS discipline_id,
    discipline.groupName AS discipline_groupName,

    -- Material Testings
    materialTestings.id AS materialTestings_id,
    materialTestings.materialId AS materialTestings_materialId,
    materialTestings.scopeType AS materialTestings_scopeType,
    materialTestings.testName AS materialTestings_testName,
    materialTestings.testMethod AS materialTestings_testMethod,
    materialTestings.rangeLower AS materialTestings_rangeLower,
    materialTestings.rangeHigher AS materialTestings_rangeHigher,
    materialTestings.muValue AS materialTestings_muValue,
    materialTestings.testValue AS materialTestings_testValue,
    materialTestings.location AS materialTestings_location,
    materialTestings.masterEquipmentId AS materialTestings_masterEquipmentId,
    materialTestings.status AS materialTestings_status

  FROM observationSheet
  LEFT JOIN materialTestings ON materialTestings.id = observationSheet.testId
  LEFT JOIN materialScope ON materialScope.id = materialTestings.materialId
  LEFT JOIN inwardTests ON FIND_IN_SET(inwardTests.id, observationSheet.inwardTestId)
  LEFT JOIN inward ON observationSheet.inwardId = inward.id 
  LEFT JOIN jobRegister ON inward.jobId = jobRegister.id 
  LEFT JOIN discipline ON materialScope.groupId = discipline.id 
  LEFT JOIN certificate ON observationSheet.certificateId = certificate.id AND certificate.status != -1
  
  -- Tested By Joins
LEFT JOIN userMaster AS testedByUser ON observationSheet.testedBy = testedByUser.id
LEFT JOIN employeeOtherData AS testedByEmpData ON testedByUser.employeeId = testedByEmpData.employeeId

-- Approved By Joins
LEFT JOIN userMaster AS approvedByUser ON observationSheet.approvedBy = approvedByUser.id
LEFT JOIN employeeOtherData AS approvedByEmpData ON approvedByUser.employeeId = approvedByEmpData.employeeId`;